import { useState } from 'react'
import { IconeCamera } from '../IconesDaFicha'

// Ciclo 1 (spec 2026-09-30, decisao 7): mostra a foto da URL ou a camera;
// tocar leva ao campo Foto (URL). No ciclo 2 o toque abre camera/galeria.
export default function CaixaFoto({ url, aoTocar }: { url: string; aoTocar: () => void }) {
  const [quebrou, setQuebrou] = useState<string | null>(null)
  const mostrar = url.trim() !== '' && quebrou !== url
  return (
    <button type="button" aria-label="Foto do produto" onClick={aoTocar}
      className="w-28 h-28 shrink-0 rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 overflow-hidden flex flex-col items-center justify-center gap-1 text-slate-500">
      {mostrar ? (
        <img src={url} alt="" className="w-full h-full object-cover" onError={() => setQuebrou(url)} />
      ) : (
        <>
          <IconeCamera tamanho={28} />
          <span className="text-xs font-medium text-slate-600">Adicionar foto</span>
          <span className="text-[10px]">URL da imagem</span>
        </>
      )}
    </button>
  )
}
